import styled from "styled-components";
import { devices } from "@/constants/media";
import { ToggleButton } from "@/ui";

export const StyledEndCallToggleButton = styled(ToggleButton)`
  background-color: var(--color-danger);
  width: 68px;
  border-radius: 80px;
  svg {
    transform: rotate(135deg);
  }
  @media ${devices.sm} {
    width: 40px;
  }
`;
